import Navbar from "../../components/main/Navbar";
import DeleteModal from "../../components/atoms/DeleteModal";
import {Toaster} from "react-hot-toast";
import {HeaderClientList} from "../../data/TablesHeader";
import ListsOperations from "../../tools/consts";
import React from "react";
import Loading from "../../components/atoms/Loading";
import Table2 from "../../components/main/Table/Table2";
import {useClientContext} from "./ClientContext";
import TableSearchHeader from "../../components/CustomTable/TableSearchHeader";
import ListPaginationWithLimit from "../../components/pagination/ListPaginationWithLimit";
import EditClientModal from "./EditClientModal";


const ClientsScreen = () => {
    const {
        onAcceptDeleteClientClick,
        onSearchBtnClick,
        changePage,
        closeModal,
        modalState,
        onDevicePerPageChange,
        listState,
        openDeleteModal,
        openAddEditModal,
    } = useClientContext();
    return (<div className="pb-7.5px">
        <Navbar titles={["کاربر‌ها", "فهرست مشتریان"]}/>
        {<div
            className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
            dir="rtl">
            <TableSearchHeader
                title={"فهرست مشتریان"}
                number={listState.countAll}
                placeholder={"جست و جو: شماره تماس، نام"}
                onSearchBtnClick={onSearchBtnClick}
                buttnText={"افزودن مشتری جدید"}
                hasBtn={true}
                onClearFiltersClick={listState.pageNumber!==1 || listState.pageLimit!==10 || listState.searchQuery!==""}

                exportFile={false}
                path={""}
                onClick={()=>{
                    openAddEditModal()
                }}
            />
            {listState.loading ? (<Loading height={"h-66"}/>) : (<>
                <Table2
                    headers={HeaderClientList}
                    tableData={listState.list}
                    operations={ListsOperations.getClientList(openDeleteModal, openAddEditModal)}
                    emptyText={"تاریخچه‌ای یافت نشد"}
                    heightEmptyState={'h-66'}
                    pageNumber={listState.pageNumber}
                    limit={listState.pageLimit}
                    hasOperation={true}
                />
                <ListPaginationWithLimit
                    changePage={changePage}
                    countAll={listState.countAll}
                    currentPage={listState.pageNumber}
                    devicePerPageLimit={listState.pageLimit}
                    onDevicePerPageChange={onDevicePerPageChange}
                />
            </>)}

            <EditClientModal/>

            <DeleteModal
                text={`آیا برای حذف “${modalState.selectedItem==null?"":modalState.selectedItem.name}” مطمئن هستید؟`}
                showDeleteModal={modalState.mode === "delete" && modalState.isOpen}
                closeDeleteModal={closeModal}
                RemoveItem={onAcceptDeleteClientClick}
                title="اخطار حذف اطلاعات"
            />
            <Toaster/>
        </div>}
    </div>);
}
export default ClientsScreen